import * as React from 'react';
import api from '../../../services/api';
import {
  DataGrid,
  GridActionsCellItem
} from '@mui/x-data-grid';
import {
  Paper,
  Button,
  Box,
  Container,
  FormControl,
  Stack,
  DialogContentText,
  Divider,
  Typography,
  Popover,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { Checkbox as MUICheckbox } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useStoreActions } from 'easy-peasy';
import {
  Select,
  TextField,
  Checkbox,
  DateField,
  NoRowsOverlay,
  OrderList,
  IntegerField
} from '../../../components';
import DialogoLista from './DialogoLista';
import { opcaoTematica, listaODS } from './static';
import yupnanable from '../../../services/yup-nanable.js';

const DadosGerais = ({ watchEmpresaId, ano }) => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDlgLista, setOpenDlgLista] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [selectedLista, setSelectedLista] = React.useState('');


  //Funções Popover
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl)

  const schema = yup.object({
    possuiMapeamento: yup.boolean()
      .label('A minha empresa possui um mapeamento de fóruns/conselhos de desenvolvimento local com representatividade(governo local, comunidade, instituições da sociedade civil, empresas) nos territórios onde atua.'),
    fazParteEstrategia: yup.boolean()
      .label('A participação nos fóruns/conselhos de desenvolvimento local faz parte da estratégia da minha empresa.'),
    priorizamTematica: yup.number().integer().nullable()
      .label('Priorizam temática'),
    saude: yup.boolean()
      .label('Saúde'),
    educacao: yup.boolean()
      .label('Educação'),
    infraestruturaUrbana: yup.boolean()
      .label('Infraestrutura Urbana'),
    saneamentoBasico: yup.boolean()
      .label('Saneamento Básico'),
    segurancaPublica: yup.boolean()
      .label('Segurança Publica'),
    direitosHumanos: yup.boolean()
      .label('Direitos Humanos'),
    meioAmbiente: yup.boolean()
      .label('Meio Ambiente'),
    diversidadeInclusao: yup.boolean()
      .label('Diversidade e Inclusão'),
    geracaoDeRenda: yup.boolean()
      .label('Geração de Renda'),
    diversificacaoEconomica: yup.boolean()
      .label('Diversificação Econômica'),
    outro: yup.string().nullable(),
    //Mao de Obra
    incentivaContratacaoLocal: yup.boolean()
      .label('A minha empresa incentiva e prioriza a contratação de mão de obra local própria'),
    metasFormais: yup.boolean()
      .label('A minha empresa tem metas formais para contratação de mão de obra local própria.'),
    contratadosLocalmente: yup.number().integer().nullable().nanable()
      .label('Contratados localmente'),
    locaisProprios: yup.number().integer().nullable().nanable()
      .label('Locais proprios'),
    locaisTerceiros: yup.number().integer().nullable().nanable()
      .label('Locais de terceiros'),
    metaCotratacaoEmpresa: yup.number().integer().nullable().nanable()
      .label('Meta mão de obra (%)'),
    prazoMetaCotratacao: yup.date().nullable()
      .label('Prazo contratação local'),
    incentivaContratacaoTerceiros: yup.boolean()
      .label('A minha empresa incentiva e prioriza a contratação de mão de obra local de terceiros.'),
    metasFormaisTerceiros: yup.boolean()
      .label('A minha empresa tem metas formais para contratação de mão de obra local de terceiros.'),
    metaCotratacaoTerceiros: yup.number().integer().nullable().nanable()
      .label('Meta terceiros (%)'),
    prazoCotratacaoTerceiros: yup.date().nullable()
      .label('Prazo contratação terceiros'),
    //ODS
    empresaAdota: yup.boolean()
      .label('A minha empresa adota os Objetivos de Desenvolvimento Sustentável (ODSs) da ONU orientando suas políticas e ações sociais.'),
    empresaIncentiva: yup.boolean()
      .label('A minha empresa incentiva à adoção das ODS pelos agentes locais (governo local, comunidade, instituições da sociedade civil, empresas) nos territórios onde atua.'),
    acoesImplementadas: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Ações implementadas'),
    ordemOds: yup.array().nullable(),

    //Formaçao e desenvolvimento
    formacaoLiderancaInterno: yup.boolean()
      .label('A minha empresa possui programas de formação de lideranças da mineração (Público interno) nos territórios com foco na agenda de desenvolvimento local e regional.'),
    metaFormacaoInterno: yup.number().integer().nullable().nanable()
      .label('Meta lideranças (%)'),
    tematicasInterno: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Quais as principais temáticas abordadas no programa de formação?'),
    formacaoPublicoExterno: yup.boolean()
      .label('A minha empresa incentiva/desenvolve junto aos municípios um programa de formação do público externo nos territórios com foco na agenda de desenvolvimento local e regional?'),
    metaFormacaoExterno: yup.number().integer().nullable().nanable()
      .label('Meta lideranças multiplicadoras (%)'),
    tematicasExterno: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Quais as principais temáticas abordadas no programa de formação?'),
    observacao: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Observações'),

  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, setValue,
          watch, formState: { isDirty, isSubmitting }
        } = useFormRef;

  const ordemOds = watch('ordemOds');

  const onSave = async (data) => {
    startLoading();
    let result;
    try {
      if (data.id) {
        result = await api.http.put(`/07/desenvolvimento-territorios/empresa/${watchEmpresaId}/${data.id}`, {
          ...data,
          ano
        });
      } else {
        result = await api.http.post(`/07/desenvolvimento-territorios/empresa/${watchEmpresaId}`, {
          ...data,
          ano
        });
      }
      reset(result.data)
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const loadDadosGerais = async (mount) => {
    startLoading();
    try {
      let getDadosGeais = (await api.http.get(`/07/desenvolvimento-territorios/empresa/${watchEmpresaId}/${ano}`));
      if (mount.isMounted)
        reset(getDadosGeais.data);
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            //Fóruns/Conselhos de desenvolvimento local
            possuiMapeamento: false,
            fazParteEstrategia: false,
            priorizamTematica: null,
            saude: false,
            educacao: false,
            infraestruturaUrbana: false,
            saneamentoBasico: false,
            segurancaPublica: false,
            direitosHumanos: false,
            meioAmbiente: false,
            diversidadeInclusao: false,
            geracaoDeRenda: false,
            diversificacaoEconomica: false,
            outro: '',
            //Mão de Obra
            incentivaContratacaoLocal: false,
            metasFormais: false,
            contratadosLocalmente: '',
            locaisProprios: '',
            locaisTerceiros: '',
            metaCotratacaoEmpresa: '',
            prazoMetaCotratacao: null,
            incentivaContratacaoTerceiros: false,
            metasFormaisTerceiros: false,
            metaCotratacaoTerceiros: '',
            prazoCotratacaoTerceiros: null,
            //ODSs
            empresaAdota: false,
            empresaIncentiva: false,
            acoesImplementadas: '',
            ordemOds: [],
            //Formação e desenvolvimento
            formacaoLiderancaInterno: false,
            metaFormacaoInterno: '',
            tematicasInterno: '',
            formacaoPublicoExterno: false,
            metaFormacaoExterno: '',
            tematicasExterno: '',

            observacao: '',
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    };
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadDadosGerais(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [watchEmpresaId, ano]);

  // dialogo e datagrid
  const loadLista = async (mount) => {
    startLoading();
    try {
      let getRows = (
        await api.http.get(
          `/07/lista-forum-conselho/empresa/${watchEmpresaId}/${ano}`
        )
      ).data;
      if (mount.isMounted)
        setRows(getRows);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };
  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadLista(mount)
    return () => {
      mount.isMounted = false;
    };
  }, [ano, watchEmpresaId])

  const deleteList = React.useCallback((id) => async () => {
    startLoading();
    try {
      await api.http.delete(`/07/lista-forum-conselho/empresa/${watchEmpresaId}/${id}`);
      let mount = {
        isMounted: true
      };
      loadLista(mount)
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  }, []);

  //OrderList
  const onChangeOrderOds=(e, option)=>{
    if(ordemOds.includes(option.id)){
      const newOrdemOds = ordemOds.filter((ordem)=> ordem != option.id )
      setValue('ordemOds',newOrdemOds,{ shouldDirty: true })
    }else{
      setValue('ordemOds', [...ordemOds, option.id], { shouldDirty: true });
    }
  }

  const columns = React.useMemo(
    () => [{
      field: "nomeForum",
      flex: 1,
      headerName: 'Nome do Fórum/Conselho',
      editable: true,

    }, {
      field: 'participaAtivamente',
      headerName: 'Participa efetivamente?',
      flex: 1,
      valueGetter: (value) => {
        return value ? 'SIM' : 'NÃO';
      }

    }, {
      field: 'actions',
      type: 'actions',
      headerName: 'Remover',
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={deleteList(params.id)}
        />
      ],
    }], [deleteList]
  );
  const onRowClick = (params, event, details) => {
    setSelectedLista(params.row);
    setOpenDlgLista(true);
  };
  const novoRegistro = async () => {
    setOpenDlgLista(true);
  };

  const onCloseDlgLista = (reload = false) => {
    setOpenDlgLista(false);
    let mount = {
      isMounted: true
    };
    if (reload) {
      loadLista(mount)
    }
  };

  return (
    (<Container maxWidth="false">
      <Divider>
        <h3>Fóruns/Conselhos de desenvolvimento local</h3>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl sx={{textAlign: 'left'}}>
          <Checkbox field="possuiMapeamento"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      {/* Dialogo e DataGrid */}
      <DialogoLista
        watchEmpresaId={watchEmpresaId}
        ano={ano}
        selectedLista={selectedLista}
        open={openDlgLista}
        onClose={onCloseDlgLista} />
      <Box >
        <Grid container spacing={3} sx={{ 'my': 2 }}>
          <Grid style={{ 'textAlign': 'left' }} size="grow">
            <Typography variant="h5">Listar os fóruns/conselhos de desenvolvimento locais mapeados:</Typography>
          </Grid>
          <Grid style={{ 'textAlign': 'right' }} size="grow">
            <Button color="primary" variant="outlined" onClick={novoRegistro}>
              Novo Fórum/Conselho
            </Button>
          </Grid>
        </Grid>
        <Paper
          variant="elevation"
          elevation={2} sx={{ mb: 5, }}
          style={{ height: 400, width: '100%' }} >
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            onRowClick={onRowClick}
            slots={{ noRowsOverlay: NoRowsOverlay }}
            disableSelectionOnClick
          />
        </Paper>
      </Box>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="fazParteEstrategia"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Os fóruns/conselhos priorizam temáticas para discussão sobre o desenvolvimento local?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <Select
              field="priorizamTematica"
              options={opcaoTematica}
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
      </Grid>
      <Stack direction="row" sx={{ textAlign: 'left', mt: 2 }}  >
        <p>
          Quais as principais temáticas referentes ao desenvolvimento territorial local constam no planejamento estratégico da sua empresa?
        </p>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="saude"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="educacao"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="infraestruturaUrbana"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="saneamentoBasico"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="segurancaPublica"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="direitosHumanos"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="meioAmbiente"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="diversidadeInclusao"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl  >
          <Checkbox field="geracaoDeRenda"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="diversificacaoEconomica"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <p>Outro:</p>
        <TextField
          sx={{ ml: 2 }}
          field="outro"
          schema={schema}
          useFormRef={useFormRef}
        />
      </Stack>
      <Divider sx={{mt:3}}>
        <h3>Mão de Obra</h3>
      </Divider>
      <FormControl fullWidth sx={{flexDirection:'row', alignItems: 'center'}}>
        <Checkbox field="incentivaContratacaoLocal"
                  schema={schema} useFormRef={useFormRef} />
        <HelpOutlineIcon
          onClick={handlePopoverOpen}

        />
      </FormControl>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }}>
          Mão de obra local corresponde à força de trabalho resultante da contratação da pessoa residente
          (determinada por comprovante de endereço) no município em que a mineradora atua, no momento da contratação.
        </Typography>
      </Popover>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="metasFormais"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        mt:2,
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 12
          }}>
          <Typography>Tendo em vista o número total de funcionários da sua empresa no ano de referência:</Typography>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Destes, quantos são contratados localmente:</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="contratadosLocalmente"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 8
          }}>
          <Typography>Destes locais, quantos são próprios:</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="locaisProprios"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Destes locais, quantos são terceiros:</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="locaisTerceiros"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 8
          }}>
          <Typography>Qual a meta de priorização e contratação de mão de obra local própria adotada pela empresa?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="metaCotratacaoEmpresa"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Qual o prazo para cumprir esta meta?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <DateField
              field="prazoMetaCotratacao"
              views={['year', 'month']}
              disabled={false}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>
        </Grid>
      </Grid>
      <Divider sx={{my:3}}>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="incentivaContratacaoTerceiros"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'center', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="metasFormaisTerceiros"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        mt:2,
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Qual a meta de priorização e contratação de mão de obra local de terceiros adotada pela empresa?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="metaCotratacaoTerceiros"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Qual o prazo para cumprir esta meta?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <DateField
              field="prazoCotratacaoTerceiros"
              views={['year', 'month']}
              disabled={false}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>ODSs</h3>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'left', mb:3 }}  >
        <FormControl  >
          <Checkbox field="empresaAdota"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb:3 }}  >
        <FormControl  >
          <Checkbox field="empresaIncentiva"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Box direction='column' sx={{ textAlign: 'left' }}>
        <p>
          Listar ações implementadas (uma ação por linha):
        </p>
        <FormControl fullWidth >
          <TextField
            field="acoesImplementadas"
            type="text"
            fullWidth
            multiline rows={4}
            schema={schema} useFormRef={useFormRef}
            inputProps={{ maxLength: 1000 }} />
        </FormControl>
      </Box>
      <Box sx={{ textAlign: 'left', mt: 2 }}>
        <p>Quais ODSs a sua empresa priorizou?</p>
      </Box>
      <FormGroup>
        {
          listaODS.map((option) => {
            return (
              <FormControlLabel
                key={option.id}
                control={<MUICheckbox
                                                      key={option.id}
                           checked={ordemOds && ordemOds.includes(option.id)?true:false}
                           name={'itemODS' + option.id}
                           onChange={(e) => onChangeOrderOds(e, option)}
               />
                        }
                label={option.label}
              />
            );
          })
        }
      </FormGroup>
      <Divider sx={{mt:3}}>
        <h3>Hierarquização dos ODSs priorizados</h3>
      </Divider>
      <DialogContentText>
        Por favor, ordene as ODSs de acordo com a importancia para sua empresa.
      </DialogContentText>
      <OrderList
        field="ordemOds"
        useFormRef={useFormRef}
        options={listaODS}
      />
      <Divider sx={{ mt: 3 }}>
        <h3>Formação e desenvolvimento</h3>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'left', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="formacaoLiderancaInterno"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', alignItems: 'center' }}  >
        <p>A empresa tem uma meta para formação de lideranças da mineração (Público interno)? Se sim, especificar:</p>
        <FormControl sx={{ width: 150 }}>
          <IntegerField
            field="metaFormacaoInterno"
            schema={schema}
            useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Box sx={{ textAlign: 'left', mb: 4 }}>
        <p>Quais as principais temáticas abordadas no programa de formação? Especificar uma por linha:</p>
        <FormControl fullWidth>
          <TextField
            field="tematicasInterno"
            type="text"
            fullWidth
            multiline rows={4}
            schema={schema} useFormRef={useFormRef}
            inputProps={{ maxLength: 1000 }} />
        </FormControl>
      </Box>
      <Stack direction="row" sx={{ textAlign: 'left', alignItems: 'center' }}  >
        <FormControl  >
          <Checkbox field="formacaoPublicoExterno"
                    schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', alignItems: 'center' }}  >
        <p>A empresa tem uma meta para formação de lideranças multiplicadoras (Público externo)? Se sim, especificar:</p>
        <FormControl sx={{ width: 150 }}>
          <IntegerField
            field="metaFormacaoExterno"
            schema={schema}
            useFormRef={useFormRef} />
        </FormControl>
      </Stack>
      <Box sx={{ textAlign: 'left', mb: 4 }}>
        <p>Quais as principais temáticas abordadas no programa de formação? Especificar uma por linha:</p>
        <FormControl fullWidth>
          <TextField
            field="tematicasExterno"
            type="text"
            fullWidth
            multiline rows={4}
            schema={schema} useFormRef={useFormRef}
            inputProps={{ maxLength: 1000 }} />
        </FormControl>
      </Box>
      <Divider>
        <h3>Observações Finais</h3>
      </Divider>
      <Box sx={{ textAlign: 'left' }}>
        <p>Deixe seu comentário ou outras informações que considerar importante:</p>
        <FormControl fullWidth>
          <TextField
            field="observacao"
            type="text"
            fullWidth
            multiline rows={4}
            schema={schema} useFormRef={useFormRef}
            inputProps={{ maxLength: 1000 }} />
        </FormControl>
      </Box>
      <Box>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(onSave)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>
    </Container>)
  );
};
export default DadosGerais
